/**
 * Run Q / Q-4 — a route that belongs to an optional module.
 *
 * Hiding the sidebar item is not enough: the URL is still typed, bookmarked and
 * linked. A disabled module redirects to the dashboard rather than rendering a
 * page the clinic has switched off.
 */
import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useClinicModules } from '@/hooks/useClinicModules';
import type { ClinicModules } from '@/lib/clinicModules';

interface Props {
  module: keyof ClinicModules;
  children: ReactNode;
}

export function RequireModule({ module, children }: Props): JSX.Element {
  const state = useClinicModules();
  // Render nothing while the flag is unknown — showing the page and then
  // yanking it away is worse than a blank frame for one request.
  if (state.isLoading) return <div aria-busy="true" />;
  if (!state[module]) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
